// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalBody_root__2LJs8","messages":"ModalBody_messages__33Uv7","spin":"ModalBody_spin__2lBYC"};